import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";


interface InfoType {
  type: "info";
  text: string;
  icon: string
}

interface HomeCardProps {
  type: InfoType;
  navigate: string;
  target?: string;
}

const HomeCard: React.FC<HomeCardProps> = ({
  type,
  navigate,
  target = "_self",
}) => {
  return (
    <div className="card card-link" style={{ minHeight: "8.5rem" }}>
      <div className="card-body row d-flex align-items-center justify-content-center">
        <div className="col-xxl-4">
          <img src={type.icon} alt={type.text} style={{ width:"100%", maxWidth:"43px"}}/>
        </div>
        <div className="col-xxl-8">
          <h5 className="text-iica-light-blue">{type.text}</h5>
        </div>
      </div>
      {navigate && <Link to={navigate} target={target} />}
    </div>
  );
};

export default HomeCard;
